import { render, staticRenderFns } from "./SubmitForm18.vue?vue&type=template&id=64e8e776&scoped=true"
import script from "./SubmitForm18.vue?vue&type=script&lang=ts"
export * from "./SubmitForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8e776",
  null
  
)

export default component.exports